import { DataSource, Image, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutResponsibilityManageHierarchyLevel extends Layout {
    imageInfo: Image;
    labelHierarchyLevel: Label;
    labelInfo: Label;
    panelInfo: Panel;
    panelManageHierarchyLevel: Panel;
    sourceHierarchyLevel: DataSource;
    tableHierarchyLevel: Table;
}
